import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { Stepper, Step } from "../../../UI/Stepper";
import classes from "./EditAssessmentWithContent.module.css";
import AssessmentDetails from "./AssessmentDetails";
import ExposeAndDuedate from "./ExposeAndDuedate";
import AddProject from "./AddProject";
import Attachments from "./Attachments";
import Final from "./Final";
import { assessmentsApi } from '../../../../utils'
import { SourceTypeTextEnum } from '../../../../models/SourceTypeEnum'
import { useNavigate } from "react-router-dom";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import moment from "moment";
import { ActivityTypeEnum, ActivityTypeEnumText } from "../../../../models/ActivityTypeEnum";

const EditAssessmentWithContent = ({ idLesson, courseName, tocName, isProfession, studyGroupId, activityType }) => {

    const texts = useSelector(state => state.translate.texts);
    const location = useLocation();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const homeUrl = useSelector((state) => state.application.homeUrl);

    const [assessment, setAssessment] = useState({
        id: null,
        name: "",
        description: null,
        allowDraft: null,
        dueDate: null,
        contentData: "",
        baseProject: {},
        // contentData contain these
        baseProjectId: null,
        attachments: []
    })

    useEffect(() => {
        async function fetchAssessmentData() {
            assessmentsApi.assessmentsFilterIdPost(idLesson, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.assessmentsFilterError, error: error, statusCode: response?.statusCode, message: "assessmentsFilterIdPost " + error.message, level: 2, component: "EditAssessmentWithContent", line: 39 }))
                }
                else {
                    let newAssessment
                    if (resdata.contentData) {
                        let contentDataObj = JSON.parse(resdata.contentData)
                        let newBaseProjectId = contentDataObj.BaseProjectId
                        let newAttachments = contentDataObj.Attachments
                        newAssessment = {
                            id: resdata.id,
                            name: resdata.name,
                            description: resdata.description,
                            allowDraft: resdata.allowDraft,
                            dueDate: resdata.dueDate,
                            baseProject: resdata.baseProject,
                            filesBaseUrl: resdata.filesBaseUrl,
                            contentData: resdata.contentData,
                            baseProjectId: newBaseProjectId,
                            attachments: newAttachments
                        }
                    }
                    else {
                        newAssessment = {
                            id: resdata.id,
                            name: resdata.name,
                            description: resdata.description,
                            allowDraft: resdata.allowDraft,
                            dueDate: resdata.dueDate,
                            baseProject: resdata.baseProject,
                            filesBaseUrl: resdata.filesBaseUrl,
                            contentData: resdata.contentData
                        }
                    }
                    setAssessment(newAssessment)
                }
            })
        }
        if (idLesson) {
            fetchAssessmentData()
        }
    }, [])

    const getActivityTypeText = (type) => {
        const entry = Object.entries(ActivityTypeEnum).find(([key, value]) => value === type);
        return entry ? ActivityTypeEnumText[entry[0]] : null;
    }

    const createOrUpdate = (newAssessment) => {
        if (!newAssessment.id) {
            let data = {
                lessonId: location.state?.lessonId,
                sourceType: SourceTypeTextEnum.IDE,
                activityType: getActivityTypeText(activityType),
                name: newAssessment.name,
                description: newAssessment.description
            }
            assessmentsApi.assessmentsAddPost({ assessmentAddInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.assessmentsAddError, error: error, statusCode: response?.statusCode, message: "assessmentsAddPost " + error.message, level: 2, component: "EditAssessmentWithContent", line: 91 }))
                }
                else {
                    console.log('resdata', resdata);
                    // filesBaseUrl - needed?
                    newAssessment.id = resdata.id
                    newAssessment.filesBaseUrl = resdata.filesBaseUrl
                    newAssessment.contentData = resdata.contentData
                    let contentDataObj = JSON.parse(resdata.contentData)
                    newAssessment.BaseProjectId = contentDataObj.BaseProjectId
                    newAssessment.Attachments = contentDataObj.Attachments
                    setAssessment(newAssessment)
                }
            })
        } else {
            let data = {
                id: newAssessment.id,
                name: newAssessment.name,
                description: newAssessment.description,
                dueDate: newAssessment.dueDate && moment(newAssessment.dueDate).format("YYYY-MM-DD 23:59:59"),
                contentData: newAssessment.contentData,
                allowDraft: newAssessment.allowDraft
            }
            assessmentsApi.assessmentsUpdatePost({ assessmentUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.assessmentsUpdateError, error: error, statusCode: response?.statusCode, message: "assessmentsUpdatePost " + error.message, level: 2, component: "EditAssessmentWithContent", line: 120 }))
                }
                else {
                    setAssessment(newAssessment)
                }
            })
        }
    }

    // AssessmentDetails
    const handleChangeBaseProperties = (name, description) => {
        let newAssessment = { ...assessment, description: description, name: name }
        createOrUpdate(newAssessment)
    }
    // ExposeAndDuedate
    const handleChangeEnableDraft = (allowDraft) => {
        let newAssessment = { ...assessment, allowDraft: allowDraft }
        createOrUpdate(newAssessment)
    }
    const handleChangeDueDate = (dueDate) => {
        let newAssessment = { ...assessment, dueDate: dueDate }
        createOrUpdate(newAssessment)
    }
    // Files
    const handleChangeBaseProject = (baseProject) => {
        setAssessment((prevAssessment) => ({ ...prevAssessment, baseProject: baseProject }))
    }
    const handleChangeContentData = (contentData) => {
        let contentDataObj = JSON.parse(contentData)
        let newBaseProjectId = contentDataObj.BaseProjectId
        let newAttachments = contentDataObj.Attachments
        setAssessment((prevAssessment) => ({ ...prevAssessment, contentData: contentData, baseProjectId: newBaseProjectId, attachments: newAttachments }))
    }

    const onEnd = () => {
        if (studyGroupId)
            navigate(`${homeUrl}/${isProfession ? "admin/disciplines" : "courses"}/${studyGroupId}`)
        else
            navigate(`${homeUrl}/${isProfession ? "admin/disciplines" : "courses"}`)
    }

    return (
        <div className={classes.NewAssessment}>
            <Stepper onEnd={onEnd} title={!!(idLesson) ? texts.editAssessment : texts.openNewAssessment} courseName={courseName} tocName={tocName} subTitle={assessment.name ? assessment.name : texts.newAssessment} canEditAll={!!(idLesson)} arrowOnClick={() => { navigate(-1) }}>
                {
                    [
                        <Step description={`${texts.details} ${texts.assessment}`} buttonText={texts.saveAndContinue}><AssessmentDetails assessment={assessment} handleChangeBaseProperties={handleChangeBaseProperties} /></Step>,
                        ActivityTypeEnum[activityType] === ActivityTypeEnum.Final && <Step description={texts.exposeAndDuedate} buttonText={texts.continue}><ExposeAndDuedate assessment={assessment} handleChangeEnableDraft={handleChangeEnableDraft} handleChangeDueDate={handleChangeDueDate} /></Step>,
                        <Step description={texts.addProject} buttonText={texts.continue}><AddProject assessment={assessment} handleChangeContentData={handleChangeContentData} handleChangeBaseProject={handleChangeBaseProject} isNew={!idLesson && !assessment.id} /></Step>,
                        <Step description={texts.attachments} buttonText={texts.continue}><Attachments assessment={assessment} handleChangeContentData={handleChangeContentData} /></Step>,
                        <Step><Final /></Step>
                    ].filter(s => s).map((s, index) => ({ ...s, key: index }))
                }
            </Stepper>
        </div>
    )
}

export default EditAssessmentWithContent;